// src/pages/signature/SignatureVerifyPage.tsx
// Public (non-admin) signature verification lookup — see docs/ux/signature-ia.md
// section 1. Not AdminRoute-gated: any authenticated user can verify a
// document's signatures. Do not confuse with workflow's VerifySignedDecision,
// which is a separate signed-decision feature this page does not touch.

import { observer } from '@react';
import { VerifyLookup } from '@/features/signature/VerifyLookup';

export const SignatureVerifyPage = observer(() => <VerifyLookup />);

export default SignatureVerifyPage;
